import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useCallback, useEffect, useState } from 'react';
import { datesArrayToDateString } from "../helpers";

var defineFilters = function defineFilters(filters) {
  return filters.map(function (filter) {
    if (filter.value && filter.type === 'date') {
      return {
        name: filter.name,
        value: datesArrayToDateString(filter.value)
      };
    }

    if (filter.value && filter.type === 'select') {
      return _objectSpread({
        name: filter.name
      }, filter.value);
    }

    return filter.value && {
      name: filter.name,
      value: filter.value
    };
  }).filter(Boolean);
};

export var useComplexFilter = function useComplexFilter(_ref) {
  var filterList = _ref.filterList,
      onAccept = _ref.onAccept,
      onClearActiveFilter = _ref.onClearActiveFilter;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(filterList),
      _useState4 = _slicedToArray(_useState3, 2),
      initialState = _useState4[0],
      setInitialState = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      activeFilters = _useState6[0],
      setActiveFilters = _useState6[1];

  useEffect(function () {
    setInitialState(filterList);
    setActiveFilters(function () {
      return defineFilters(filterList);
    });
  }, [filterList]);
  var handleToggle = useCallback(function () {
    setIsOpen(function (prevState) {
      return !prevState;
    });
  }, []);
  var handleCloseBody = useCallback(function () {
    setIsOpen(false);
  }, []);
  var handleChange = useCallback(function (value, currentFilter) {
    setInitialState(function (prev) {
      return prev.map(function (filter) {
        if (filter.name === currentFilter.name) {
          return _objectSpread(_objectSpread({}, filter), {}, {
            value: value
          });
        }

        return filter;
      });
    });
  }, []);
  var handleAccept = useCallback(function () {
    var filters = defineFilters(initialState);
    setActiveFilters(defineFilters(initialState));
    handleCloseBody();
    onAccept(filters);
  }, [initialState, onAccept, handleCloseBody]);
  var handleClearActiveFilter = useCallback(function (name) {
    var clearedActiveFilters = activeFilters.filter(function (filter) {
      return filter.name !== name;
    });
    setActiveFilters(clearedActiveFilters);
    onClearActiveFilter(clearedActiveFilters);
    setInitialState(function (prevState) {
      return prevState.map(function (filter) {
        if (filter.name === name) {
          return _objectSpread(_objectSpread({}, filter), {}, {
            value: null
          });
        }

        return filter;
      });
    });
  }, [activeFilters, onClearActiveFilter]);
  return {
    initialState: initialState,
    activeFilters: activeFilters,
    isOpen: isOpen,
    handleChange: handleChange,
    handleAccept: handleAccept,
    handleToggle: handleToggle,
    handleCloseBody: handleCloseBody,
    handleClearActiveFilter: handleClearActiveFilter
  };
};